module.exports = __webpack_public_path__ + "img/img_driver_hp.c0ff1061.png";